/* Progressive enhancement: all links and native Shopify cart forms work without this file. */
(() => {
  function initModels(root = document) {
    root.querySelectorAll('[data-model-browser]').forEach(browser => {
      if (browser.dataset.ready) return;
      browser.dataset.ready = 'true';
      const links = [...browser.querySelectorAll('[data-model-tab]')];
      const panels = [...browser.querySelectorAll('[data-model-panel]')];
      const activate = index => {
        links.forEach((link, i) => { if (i === index) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
      };
      links.forEach((link, i) => link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); activate(i);
      }));
      activate(0);
    });
  }
  document.addEventListener('click', event => {
    const panel = event.target.closest('.dr-dropdown');
    document.querySelectorAll('.dr-dropdown[open]').forEach(item => { if (item !== panel || event.target.closest('a')) item.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = [...document.querySelectorAll('.dr-dropdown[open], .dr-mobile[open]')];
    open.forEach(item => { item.open = false; item.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', event => {
    const a = event.target.closest('.dr-mobile a');
    if (a) a.closest('.dr-mobile').open = false;
  });
  initModels();
  document.addEventListener('shopify:section:load', event => initModels(event.target));
})();
